import { Tooltip, Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const Meter = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  width: "100%",
  height: "20px",
  borderRadius: "10px",
  backgroundColor: theme.palette.grey[300],
  overflow: "hidden",
  boxShadow: "inset 0 1px 3px rgba(0,0,0,0.2)",
}));

const Fill = styled(Box)(({ percent, color }) => ({
  width: `${percent}%`,
  height: "100%",
  background: `linear-gradient(to right, rgba(${color}, 0.9), rgba(${color}, 0.6))`,
  display: "flex",
  alignItems: "center",
  justifyContent: percent > 10 ? "flex-end" : "flex-start", // adjust text position
  paddingRight: "6px",
  paddingLeft: "6px",
  fontSize: "0.75rem",
  whiteSpace: "nowrap",
  transition: "width 0.3s ease-in-out",
}));

export default function LineMeter({ curr, min, max }) {
  let percent = (curr / max) * 100;
  if (max <= 0 || isNaN(percent) || percent == 0) percent = 0;
  if (percent > 100) percent = 100;

  let color = "255,0,0"; // red
  if (curr == min && curr > 0) color = "250,200,0"; // yellow
  else if (curr > min) color = "55,157,1"; // green
  return (
    <Tooltip title={`Min(${min})  Max(${max})`} arrow>
      <Meter>
        <Fill percent={percent} color={color}>
          {`${Math.round(percent)}%`}
        </Fill>
      </Meter>
    </Tooltip>
  );
}
